import React, { useContext } from 'react';
import { Box } from '@material-ui/core';
import { NavLink } from 'react-router-dom';
import CmtImage from '../../../../@coremat/CmtImage';
import AppContext from '@jumbo/components/contextProvider/AppContextProvider/AppContext';
import { getImage } from '@codeArt/electron/renderer/util';


const FooterLogo = ({ color, ...props }) => {
  const { project } = useContext(AppContext);

  const {logo} = project;
  const {sm} = logo;

  const logoUrl = color === 'white' ? sm.white : sm.grey;

  if(!logoUrl) return null;

  return (
    <Box className="pointer" {...props}>
      <NavLink to="/">
        <CmtImage src={getImage(logoUrl)} alt="logo" />
      </NavLink>
    </Box>
  );
};

export default FooterLogo;
